export enum ReportFormat {
  Csv = 0,
  Pdf = 1
};
